import { Component } from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {BehaviorSubject, Observable} from "rxjs";
import {APIClientService} from "../../../common/services/apiclient.service";
import {CustomerApi} from "../../../common/apis/customer-api";

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.css']
})
export class ConfirmEmailComponent {
  token: string;

  private currentStepBs: BehaviorSubject<Step> = new BehaviorSubject<Step>(Step.LOADING);
  public currentStep$: Observable<Step> = this.currentStepBs.asObservable();

  constructor(
    private route: ActivatedRoute,
    private backendApiClientService: APIClientService,
    private customerApi: CustomerApi
  ) {}

  ngOnInit(): void {

    this.token = this.route.snapshot.params['token'];
    // this.currentStepBs.next(Step.SUCCESS);
    // this.currentStepBs.next(Step.FAILED);

    this.customerApi.confirmEmailSubscription(this.token).subscribe({
      next: () => {
        // Nothing to do. I guess.
      },
      error: () => {
        this.currentStepBs.next(Step.FAILED);
      },
      complete: () => {
        this.currentStepBs.next(Step.SUCCESS);
      }
    });
  }

  protected readonly Step = Step;
}


export enum Step {
  LOADING,
  SUCCESS,
  FAILED
}
